import COLORS from '@/constants/colors';

export enum BadgeType {
  Positive,
  Warning,
  Negative,
  Info,
  Neutral,
}

export type StatusBadgeUi = {
  statusId: string;
  textColor: string;
  backgroundColor: string;
  edgeColor: string;
  text: string;
};

export function getGenericBadge(
  type: BadgeType,
  id: string,
  label: string
): StatusBadgeUi {
  switch (type) {
    case BadgeType.Positive:
      return {
        statusId: id,
        textColor: COLORS.success_700,
        backgroundColor: COLORS.success_50,
        edgeColor: COLORS.success_200,
        text: label,
      };
    case BadgeType.Warning:
      return {
        statusId: id,
        textColor: COLORS.yellow_700,
        backgroundColor: COLORS.yellow_50,
        edgeColor: COLORS.yellow_200,
        text: label,
      };
    case BadgeType.Negative:
      return {
        statusId: id,
        textColor: COLORS.red_700,
        backgroundColor: COLORS.red_50,
        edgeColor: COLORS.red_200,
        text: label,
      };
    case BadgeType.Info:
      return {
        statusId: id,
        textColor: COLORS.blue_700,
        backgroundColor: COLORS.blue_50,
        edgeColor: COLORS.blue_200,
        text: label,
      };
    case BadgeType.Neutral:
      return {
        statusId: id,
        textColor: COLORS.gray_700,
        backgroundColor: COLORS.gray_50,
        edgeColor: COLORS.gray_200,
        text: label,
      };
  }
}
